import { NoteRoute } from '@/modules/note/v1/api/NoteRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { FileChunkParams } from '@/modules/note/v1/api/v1/files/Dto/FileChunkParams'

/** GET /api/note/v1/files/{file} с Range: байты шифротекста куска (getBytes) */
export class GetFileChunkRoute extends NoteRoute<FileChunkParams, ArrayBuffer> {
  constructor(private readonly file: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/note/v1/files/' + this.file
  }

  bytesHeaders(params: FileChunkParams): Record<string, string> {
    return { Range: `bytes=${params.from}-${params.to}` }
  }

  /** Без сервера файлов нет: пустой кусок */
  offline(): Promise<ApiResponse<ArrayBuffer>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new ArrayBuffer(0) }))
  }
}
